import { render, staticRenderFns } from "./rutas.vue?vue&type=template&id=3336fc9c&"
import script from "./rutas.vue?vue&type=script&lang=js&"
export * from "./rutas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports